import React from "react";
import Header from "../../../shared/PageHeader";
import PageFooter from "../../../shared/PageFooter";
import HeroSection from "../HeroSection";
import FAQComponent from "app/scenes/SalesPage/FaqSection";
import StepsSection from "app/scenes/SalesPage/StepsLandingPage";
import ContactForm from "../QuerySection";
import "./LandingPage.scss";
import FinkraftBenefits from "../FinkraftBenefits";
import TryProductSection from "../TryProductSection";

function LandingPage() {
  const stepsData = {
    subtitle: "STEP BY STEP",
    title: "How Does It Work",
    description:
      "Our streamlined process ensures you get your GST invoice in just a few clicks, fast, accurate, and compliant.",
    steps: [
      {
        icon: (
          <svg
            width="668"
            height="668"
            viewBox="0 0 668 668"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M300.667 0.666679C355.895 0.666679 400.667 45.4382 400.667 100.667L400.67 139.689C411.095 136.005 422.313 134 434 134H567.333C622.562 134 667.333 178.772 667.333 234V567.333C667.333 622.562 622.562 667.333 567.333 667.333H100.667C45.4383 667.333 0.666748 622.562 0.666748 567.333V100.667C0.666748 45.4382 45.4383 0.666679 100.667 0.666679H300.667ZM300.667 67.3333H100.667C82.2573 67.3333 67.3334 82.2572 67.3334 100.667V567.333C67.3334 585.743 82.2573 600.667 100.667 600.667H334V100.667C334 82.2572 319.076 67.3333 300.667 67.3333ZM567.333 200.667H434C415.591 200.667 400.667 215.591 400.667 234V600.667H567.333C585.743 600.667 600.667 585.743 600.667 567.333V234C600.667 215.591 585.743 200.667 567.333 200.667ZM234 400.667C252.41 400.667 267.333 415.591 267.333 434C267.333 452.409 252.41 467.333 234 467.333H167.333C148.924 467.333 134 452.409 134 434C134 415.591 148.924 400.667 167.333 400.667H234ZM534 400.667C552.41 400.667 567.333 415.591 567.333 434C567.333 452.409 552.41 467.333 534 467.333H467.333C448.924 467.333 434 452.409 434 434C434 415.591 448.924 400.667 467.333 400.667H534ZM234 267.333C252.41 267.333 267.333 282.257 267.333 300.667C267.333 319.076 252.41 334 234 334H167.333C148.924 334 134 319.076 134 300.667C134 282.257 148.924 267.333 167.333 267.333H234ZM534 267.333C552.41 267.333 567.333 282.257 567.333 300.667C567.333 319.076 552.41 334 534 334H467.333C448.924 334 434 319.076 434 300.667C434 282.257 448.924 267.333 467.333 267.333H534ZM234 134C252.41 134 267.333 148.924 267.333 167.333C267.333 185.743 252.41 200.667 234 200.667H167.333C148.924 200.667 134 185.743 134 167.333C134 148.924 148.924 134 167.333 134H234Z"
              fill="white"
            />
          </svg>
        ),
        title: "Register Your Entity",
        description:
          "To retrieve your GST invoice, please enter your booking reference (PNR) as it appears on the ticket.",
      },
      {
        icon: (
          <svg
            width="800"
            height="800"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_2026_11"
              // style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="800"
              height="800"
            >
              <path d="M800 0H0V800H800V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_2026_11)">
              <path
                d="M400 699.997C565.685 699.997 700 565.682 700 399.997C700 234.311 565.685 99.9967 400 99.9967C234.315 99.9967 100 234.311 100 399.997C100 565.682 234.315 699.997 400 699.997Z"
                stroke="#292929"
                stroke-width="83.3333"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="white"
              />
              <path
                d="M400.333 266.667H400V267H400.333V266.667Z"
                stroke="#292929"
                stroke-width="125"
                stroke-linejoin="round"
              />
              <path
                d="M400 400V533.333"
                stroke="#292929"
                stroke-width="83.3333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        ),
        title: "Provide Basic Information",
        description:
          "Enter your company's GSTIN to ensure your invoice is generated with the correct tax details for seamless credit claims.",
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.59 9H15V4C15 3.45 14.55 3 14 3H10C9.45 3 9 3.45 9 4V9H7.41C6.52 9 6.07 10.08 6.7 10.71L11.29 15.3C11.68 15.69 12.31 15.69 12.7 15.3L17.29 10.71C17.92 10.08 17.48 9 16.59 9ZM5 19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18H6C5.45 18 5 18.45 5 19Z"
              fill="white"
            />
          </svg>
        ),
        title: "Download Invoices",
        description:
          "Get your GST invoice delivered instantly, download it to your device easy record keeping and compliance.",
      },
    ],
    buttonText: "Get Started",
  };

  const faqData = {
    title: "FAQs",
    subtitle: "Here are answers to questions our clients ask.",
    items: [
      {
        question: "When will we get the cargo and passenger invoices?",
        answer:
          "Cargo invoices are generated on a fortnightly basis: 1) 1st Fortnight (FN) invoices will be available by the 7th of the following month. 2) 2nd Fortnight (FN) invoices will be available by the 22nd of the following month. 3) For passenger invoices, the GST invoice will be generated within 30 to 35 days from the date of ticket issuance.",
      },
      {
        question: "Where should I provide GST details??",
        answer:
          "You should provide your GST details at the time of ticket issuance to ensure that your invoices are generated with the correct GSTN. In the Qatar Finkraft portal, GST details can be entered during the registration process or updated in your profile settings if needed. Providing accurate GST information will help in generating GST-compliant invoices, which you can later download from the portal.",
      },
      {
        question: "What is the procedure for getting invoices?",
        answer:
          "You need to register on the Qatar Finkraft portal. Once registered, you can log in using the credentials sent via email. After completing the required forms, the admin will verify your details and grant access to download invoices. If any issues arise, the admin will escalate them. You can search for your invoices using details like the ticket number or invoice number and download them directly. Ensure that you provide your GSTIN at the time of ticket issuance to keep your invoices GST-compliant.",
      },
      {
        question: "Is it compulsory to provide GST registration details?",
        answer:
          "Yes, it is compulsory to provide your GSTN (Goods and Services Tax Number) and relevant details. This ensures that all invoices related to your GSTN are correctly generated and shared with you. Providing accurate GST details also helps in proper tax compliance and record-keeping, making it easier for you to claim input tax credits if applicable.",
      },
      {
        question: "When will I receive the GST invoice for my ticket?",
        answer:
          "Cargo invoices are generated on a fortnightly basis: 1) 1st Fortnight (FN) invoices will be available by the 24th of the same month. 2) 2nd Fortnight (FN) invoices will be available by the 13th of the following month.",
      },
      {
        question: "May I provide my credentials to other users?",
        answer:
          "Yes, you can share your credentials within your organization or company. However, if you have admin access, you can add them as users so they can log in and download invoices directly.",
      },
      {
        question: "Can I download my invoice without a ticket number?",
        answer:
          "You must have either the invoice number or the ticket number for a specific ticket. Otherwise, you can find all invoices related to your GSTN in one folder.",
      },
    ],
  };

  const handleGetStarted = () => {
    console.log("Get Started button clicked");
  };

  return (
    <div className="landing-page" id="landing-page">
      <div className="page-header">
        <Header />
      </div>

      <div className="page-body">
        <HeroSection />
        <FinkraftBenefits />
        <StepsSection
          title={stepsData.title}
          subtitle={stepsData.subtitle}
          description={stepsData.description}
          steps={stepsData.steps}
          buttonText={stepsData.buttonText}
          onButtonClick={handleGetStarted}
        />
        <FAQComponent
          title={faqData.title}
          subtitle={faqData.subtitle}
          items={faqData.items}
        />
        <TryProductSection />
      </div>

      <div className="page-footer">
        <PageFooter companyName="Finkraft.ai" year={2025} />
      </div>
    </div>
  );
}

export default LandingPage;
